// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__INSNI","select":"styles_select__2-s-Q"};